import React from 'react'
import './SliconSprSpreder.scss'
import { useNavigate } from "react-router-dom";

import icon1 from '../../../assets/images/landingpage/icon (1).png'
import icon2 from '../../../assets/images/landingpage/icon (2).png'
import icon3 from '../../../assets/images/landingpage/icon (3).png'
import icon4 from '../../../assets/images/landingpage/icon (4).png'
import icon5 from '../../../assets/images/landingpage/icon (5).png'
import icon6 from '../../../assets/images/landingpage/icon (6).png'
import icon7 from '../../../assets/images/landingpage/icon (7).png'
import icon8 from '../../../assets/images/landingpage/icon (8).png'
import lefnew from '../../../assets/images/landingpage/ed.png'
import lefnew1 from '../../../assets/images/landingpage/lefnew.png'
import ContactUsForm from './ContactUsForm'

import Chipko from '../../../assets/images/landingpage/chipko.webp'
import econcal330 from '../../../assets/images/landingpage/econmcal330.webp'
import siliconspr100 from '../../../assets/images/landingpage/siliconspr100.webp'
import siliconspr220 from '../../../assets/images/landingpage/siliconspr220.webp'
import siliconspr225 from '../../../assets/images/landingpage/siloconspr225.webp'
import siliconsuperpreader from '../../../assets/images/landingpage/siliconsuperpreader.webp'
import wetting from '../../../assets/images/landingpage/wetting.webp'
import s330 from '../../../assets/images/landingpage/s330.webp'
import { Link } from "react-router-dom";
import Contact from '../../Contact/Contact';


function SliconSprSpreder() {
    const navigate = useNavigate();

    const handleViewDetails = (product) => {
        navigate(`/product-details/${product.name.replace(/ /g, "_")}/${product.code}`);
    };

    const products = [
        {
            name: "Silicon Super Spreader",
            code: "FX SPT 500",
            image: siliconsuperpreader
        },
        {
            name: "Powder Silicon Spreader",
            code: "FENSIL 360",
            image: econcal330
        },
        {
            name: "Silicon Super Spreader",
            code: "FX SP 225",
            image: siliconspr225
        },
        {
            name: "Silicon Super Spreader",
            code: "FX SP 100",
            image: siliconspr100
        },
        {
            name: "Silicon Super Spreader",
            code: "FX SP 220",
            image: siliconspr220
        },
        {
            name: "Economical Silicon Super Spreader",
            code: "FX SP 330",
            image: s330
        },
        {
            name: "Chipko",
            code: "DIKO WET 80",
            image: Chipko
        },
        {
            name: "Wetting Sticking Agent",
            code: "",
            image: wetting
        }
    ];

    return (
        <div className='SliconSprSpreder-landing-page'>


            <div className="fenton-page">


                {/* Hero Section */}
                <section className="fenton-hero">
                    <div className="fenton-hero-content">
                        <h1 className="fenton-title">SILICONE<br />SUPER<br />SPREADER</h1>
                        <div className="fenton-description">
                            <p>
                              Fenton Chemical is India's leading manufacturer of Silicone Super Spreader a game-changing solution that enhances agrochemical performance by improving spray coverage, penetration, and absorption.Fenton Chemicals spearheaded the adoption of this product and brought it to the forefront in India,and has been manufacturing it for the past 13 years. With a robust 500 MT/month capacity, we deliver quality, innovation, and consistency in silicone-based technologies for modern agriculture. 
                            </p>
                        </div>
                    </div>
                    <div className="fenton-hero-image">
                        <img src={lefnew} alt="Leaf" className="fenton-leaf" />
                        {/* <img  src={lefnew1} alt="Leaf" className="fenton-leaf-2" /> */}
                    </div>
                </section>

                {/* Features Section */}
                <section className="fenton-features">
                    <div className="features-box">
                        <h2 className="features-title">FEATURES</h2>
                        <div className="features-list">
                            <div className="features-col left-col">
                                <div className="feature-item">

                                    <div className="icon-sec">
                                        <img src={icon2} alt="icon" />
                                    </div>
                                    <div className="text-sec">

                                        <span>Ultra Spread</span><small>Rapid, even coverage with low surface tension</small>
                                    </div>



                                </div>


                                <div className="feature-item">
                                    <div className="icon-sec">
                                        <img src={icon3} alt="icon" />
                                    </div>
                                    <div className="text-sec">
                                        <span>Max Coverage</span><small>Reduces waste, increases efficiency</small>
                                    </div>
                                </div>






                                {/* <div className="feature-item">
                                    <div className="icon-sec">
                                        <img src={icon4} alt="icon" />
                                    </div>
                                    <div className="text-sec">
                                        <span>Superior Wetting</span><small>Improves droplet adhesion on leaves</small>
                                    </div>
                                </div> */}




                                <div className="feature-item">
                                    <div className="icon-sec">
                                        <img src={icon4} alt="icon" />
                                    </div>
                                    <div className="text-sec">
                                        <span>Rainfast</span><small>Sticks within 2 minutes, even in light rain</small>
                                    </div>
                                </div>



                                <div className="feature-item">
                                    <div className="icon-sec">
                                        <img src={icon5} alt="icon" />
                                    </div>
                                    <div className="text-sec">
                                        <span>Quick Absorption</span><small>Deep plant penetration for better results</small>
                                    </div>
                                </div>
                            </div>


                            <div className="features-col">
                                {/* <div className="feature-item"> */}
                                {/* <div className="icon-sec">
                                        <img src={icon6} alt="icon" />
                                    </div>
                                    <div className="text-sec">
                                        <span>Non-Ionic</span><small>Compatible with most agrochemicals</small>
                                    </div>
                                </div> */}
                                <div className="feature-item">
                                    <div className="icon-sec">
                                        <img src={icon6} alt="icon" />
                                    </div>
                                    <div className="text-sec">
                                        <span>Low Dose</span><small>Works effectively at minimal quantity</small>
                                    </div>
                                </div>
                                <div className="feature-item">
                                    <div className="icon-sec">
                                        <img src={icon7} alt="icon" />
                                    </div>
                                    <div className="text-sec">
                                        <span>Boosted Uptake</span><small>Enhances nutrient and pesticide absorption</small>
                                    </div>
                                </div>
                                <div className="feature-item">
                                    <div className="icon-sec">
                                        <img src={icon8} alt="icon" />
                                    </div>
                                    <div className="text-sec">
                                        <span>Highly Compatible</span><small>Mixes well with most agrochemicals</small>
                                    </div>
                                </div>
                                <div className="feature-item">
                                    <div className="icon-sec">
                                        <img src={icon1} alt="icon" />
                                    </div>
                                    <div className="text-sec">
                                        <span>Eco-Safe</span><small>Less runoff, safer for the environment</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Dosage Section */}
                <section className="fenton-dosage">
                    <div className="dosage-box">
                        <h2 className="dosage-title">DOSAGE</h2>
                        <div className="dosage-list">
                            <div className="dosage-col">
                                <div className="dosage-item">
                                    <strong>Tank Mix Application</strong>
                                    <p>Use approximately<br /><b>5 ML</b> grams per <b>15 liters</b> of water</p>
                                </div>
                                <div className="dosage-item">
                                    <strong>WP®WDG Formulations</strong>
                                    <p>Add <b>1% to 5%</b> of the total formulation</p>
                                </div>
                            </div>
                            <div className="dosage-col">
                                <div className="dosage-item">
                                    <strong>As a Dispersing Agent</strong>
                                    <p>Recommended at<br /><b>3% to 5%</b> of the formulation</p>
                                </div>
                                <div className="dosage-item">
                                    <strong>Boosted Uptake</strong>
                                    <p>Use <b>1% to 5%</b> of the total formulation</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Sub-products Section */}
                <section className="fenton-subproducts">
                    <h2 className="subproducts-title">SUB-PRODUCTS</h2>
                    <div className="subproducts-grid">
                        {products.map((product, index) => (

                            <div className="subproduct-card" key={index} onClick={() => handleViewDetails(product)}>
                                <div className="subproduct-img">
                                    <img src={product.image} alt={product.name} />
                                </div>

                                <div className="subproduct-name">{product.name}</div>
                                <div className="subproduct-code">{product.code}</div>
                                {/* <button onClick={() => handleViewDetails(product)}>View Details</button> */}
                            </div>

                        ))}
                    </div>
                </section>

                <section className="fenton-subproductss">

                    <Contact bgColor="#f5f5f5" />
                </section>
                


                {/* <ContactUsForm /> */}
            </div>
        </div>
    )
}

export default SliconSprSpreder